// Supervisor API

import axiosInstance from './axiosInstance';
import { API_ENDPOINTS } from '../config/api.config';

const { SUPERVISORS } = API_ENDPOINTS;

export const supervisorApi = {
  /** GET /admin/supervisor/list/ — params: { search, is_active, include_deleted } */
  getList: (params = {}) => axiosInstance.get(SUPERVISORS.LIST, { params }),

  /** GET /admin/supervisor/<id>/ */
  getDetail: (id) => axiosInstance.get(SUPERVISORS.DETAIL(id)),

  /** POST /admin/supervisor/create/ */
  create: (data) => axiosInstance.post(SUPERVISORS.CREATE, data),

  /** PATCH /admin/supervisor/update/<id>/ */
  update: (id, data) => axiosInstance.patch(SUPERVISORS.UPDATE(id), data),

  /** DELETE /admin/supervisor/delete/<id>/ — requires admin password in body */
  remove: (id, password) =>
    axiosInstance.delete(SUPERVISORS.DELETE(id), { data: { password } }),

  /** PATCH /admin/supervisor/<id>/active/ */
  toggleActive: (id, is_active) =>
    axiosInstance.patch(SUPERVISORS.TOGGLE_ACTIVE(id), { is_active }),

  /** POST /admin/supervisor/<id>/restore/ */
  restore: (id) => axiosInstance.post(SUPERVISORS.RESTORE(id)),

  /** GET /admin/supervisor/<id>/analytics/ — params: { period } or { from, to }
   *  One supervisor's full window: summary, every deal they priced or
   *  corrected (with car + parts), and a day-by-day rollup. */
  getAnalytics: (id, params = {}) =>
    axiosInstance.get(SUPERVISORS.ANALYTICS(id), { params }),
};
